/**
 * Score-breakdown factors the app knows how to explain. An allowlist, so a
 * factor the backend still sends during a staged rollout (or adds later) never
 * shows up under a raw key. Keep in sync with the mobile app's
 * `kScoreBreakdownKeys`.
 */
export const SCORE_BREAKDOWN_KEYS: ReadonlySet<string> = new Set([
  'irritation_penalty',
  'allergen_penalty',
  'acne_penalty',
  'photosensitizer_penalty',
  'fragrance_penalty',
  'preservative_penalty',
  'ethical_penalty',
  'inci_safety_penalty',
  'active_bonus',
  'skin_type_delta',
  'product_quality_delta',
]);

/** The known `[key, value]` pairs of a score breakdown, in payload order. */
export function knownBreakdownEntries(breakdown: Record<string, unknown>): [string, unknown][] {
  return Object.entries(breakdown).filter(([k]) => SCORE_BREAKDOWN_KEYS.has(k));
}
